import React from "react";
import Seo from "../components/Seo";
import { Header, Hero, Servicios, Membresias } from "../components/TopSections";
import NuestraHistoria from "../components/NuestraHistoria";
import { Testimonios, Contacto, Footer } from "../components/BottomSections";

const Home = () => (
  <>
    <Seo
      title="Abogados en Puerto Vallarta | Contreras & Asociados PV"
      description="Abogados en Puerto Vallarta especializados en cancelación de timeshare, derecho inmobiliario, civil, familiar y corporativo. Consulta gratuita."
      path="/"
      keywords="abogados Puerto Vallarta, cancelación timeshare, derecho familiar, derecho civil, derecho inmobiliario, contratos, despacho jurídico Puerto Vallarta"
    />
    <Header />
    <main>
      <Hero />
      <Servicios />
      <NuestraHistoria />
      <Membresias />
      <Testimonios />
      <Contacto />
    </main>
    <Footer />
  </>
);

export default Home;
